import { useEffect } from 'react';
import useRoutingInstrumentation from 'react-router-v6-instrumentation';
import { BrowserTracing } from '@sentry/tracing';
import * as Sentry from '@sentry/react';
export function useSentry() {
    var routingInstrumentation = useRoutingInstrumentation();
    useEffect(function () {
        var browserTracing = new BrowserTracing({
            routingInstrumentation: routingInstrumentation,
        });
        Sentry.init({
            dsn: process.env.REACT_APP_SENTRY_DSN,
            integrations: [browserTracing],
            // We recommend adjusting this value in production, or using tracesSampler
            // for finer control
            normalizeDepth: 10,
            tracesSampleRate: 1.0,
        });
    }, [routingInstrumentation]);
}
export default useSentry;
